export default __webpack_public_path__ + "static/media/programate-academy-blancos.043242f6.png";